(() => {
  'use strict';

  const initFitGuide = (guide) => {
    if (guide.dataset.fitGuideReady === 'true') return;
    guide.dataset.fitGuideReady = 'true';

    const tabs = [...guide.querySelectorAll('[data-fit-audience-tab]')];
    const panels = [...guide.querySelectorAll('[data-fit-audience-panel]')];
    const videos = [...guide.querySelectorAll('.nfd-fit-detail__video')];

    const pauseHiddenVideos = () => {
      videos.forEach((video) => {
        if (video.closest('[data-fit-audience-panel]')?.hidden) video.pause();
      });
    };

    const initVideos = () => {
      if (!videos.length) return;

      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !('IntersectionObserver' in window)) {
        videos.forEach((video) => video.pause());
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          const panel = video.closest('[data-fit-audience-panel]');
          const canPlay = entry.isIntersecting && entry.intersectionRatio >= 0.35 && !panel?.hidden;

          if (canPlay) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { threshold: [0, 0.35, 0.75] });

      videos.forEach((video) => observer.observe(video));
    };

    if (tabs.length >= 2 && panels.length >= 2) {
      const selectAudience = (audience, updateHash = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.fitAudienceTab === audience;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.fitAudiencePanel !== audience;
        });

        pauseHiddenVideos();

        if (updateHash && window.history?.replaceState) {
          window.history.replaceState(null, '', audience === 'women' ? '#women-fits' : '#men-fits');
        }
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectAudience(tab.dataset.fitAudienceTab, true));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextTab = tabs[(index + direction + tabs.length) % tabs.length];
          selectAudience(nextTab.dataset.fitAudienceTab, true);
          nextTab.focus();
        });
      });

      const syncFromHash = () => {
        const hash = window.location.hash;
        const target = hash ? guide.querySelector(hash) : null;
        const targetAudience = target?.closest('[data-fit-audience-panel]')?.dataset.fitAudiencePanel;
        const activeAudience = tabs.find((tab) => tab.classList.contains('is-active'))?.dataset.fitAudienceTab;
        selectAudience(targetAudience || activeAudience || 'men');
      };

      window.addEventListener('hashchange', syncFromHash);
      syncFromHash();
    }

    guide.querySelectorAll('.nfd-fit-overview__card').forEach((card) => {
      card.addEventListener('click', () => card.closest('details')?.removeAttribute('open'));
    });

    initVideos();
  };

  const initAllFitGuides = (root = document) => {
    if (root.matches?.('[data-fit-guide]')) initFitGuide(root);
    root.querySelectorAll('[data-fit-guide]').forEach(initFitGuide);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllFitGuides());
  } else {
    initAllFitGuides();
  }

  document.addEventListener('shopify:section:load', (event) => initAllFitGuides(event.target));
})();
